import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// New page: start at the top, or at the #section the link names. Pages load
// lazily, so the target may not exist yet; look for it for up to a second.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      tries += 1;
      if (el) el.scrollIntoView({ block: 'start' });
      if (el || tries > 20) clearInterval(timer);
    }, 50);
    return () => clearInterval(timer);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
